// extracted by mini-css-extract-plugin
export default {"CheckIcon":"PlansRadioGroup-module__CheckIcon__I6QZFrI"};